import { $ } from './../../helpers/query';
import Swiper from 'swiper/bundle';

export default () => {

  $('.types').each(section => {

    const tabs = $('.types__tab', section);
    const carousel = $('.types__carousel', section);

    const swiper = new Swiper(carousel.elem, {
      allowTouchMove: false,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      on: {
        init: () => {
          tabs.elem.classList.add('types__tab--active');
        }
      }
    });

    tabs.on('click', (e, tab) => {
      const index = +$(tab).getAttr('data-move-to') - 1;
      swiper.slideTo(index);
      tabs.removeClass('types__tab--active');
      tab.classList.add('types__tab--active');
    })

  });

}
